import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    mixins: [mainRegistrationMixin],
    props: {
        personKey: {
            type: [String, Number],
            required: true
        }
    },
    computed: {
        person: {
            get: function () {
                return this.registrationData.persons[this.personKey] ?? {}
            },
            set: function (person) {
                this.$store.commit('registration/setRegistrationPerson', {person: person, key: this.personKey})
            }
        },
        personAsObjectWithoutCaregiverToken() {
            if (!this.person) return {}
            let clonedPersonObject = this.$cloneDeep(this.person)
            delete clonedPersonObject.caregiverUuid
            return clonedPersonObject
        },

        availablePersonsForAddressApply() {
            const persons = this.registrationData.persons
            let participantPersons = {}
            this.registrationData.participatingPersons.forEach(person => {
                if (person !== this.personKey) {
                    if (persons[person] && ((!!(persons[person].zipId && persons[person].cityId) || !!(persons[person].zipValue && persons[person].cityValue))
                        && ((persons[person].isPostbox && persons[person].postboxNumber !== null) || (persons[person].streetId !== null && persons[person].houseNumber !== null)))) {
                        participantPersons[person] = persons[person]
                    }
                }
            })

            participantPersons['length'] = Object.keys(participantPersons).length

            return participantPersons
        },

        getNumberOfRemainingPlacesWithCurrentRegistrations() {
            return this.$store.getters['registration/getNumberOfRemainingPlacesWithCurrentRegistrations']
        },

        getNumberOfRemainingFemaleParticipantPlacesWithCurrentRegistrations() {
            return this.$store.getters['registration/getNumberOfRemainingFemaleParticipantPlacesWithCurrentRegistrations']
        },

        getNumberOfRemainingMaleParticipantPlacesWithCurrentRegistrations() {
            return this.$store.getters['registration/getNumberOfRemainingMaleParticipantPlacesWithCurrentRegistrations']
        }
    },
    watch: {
    }
}
